/**
 * Styled Components - Created by eduardoquintero on 18/02/20.
 */
import styled from 'styled-components'
import Button from 'antd/lib/button'
import Spin from 'antd/lib/spin'
import {
  BLACK,
  WHITE,
  GRAY_LIGHTEST,
  GRAY_LIGHT,
  RED,
  GRAY_SKELETON
} from '../../../theme/colors'

export const Container = styled.div`
  display: flex;
  animation: fade-in-top 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-top {
    0% {
      transform: translateY(-10px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @media (max-width: 698px) {
    flex-wrap: wrap;
    padding: 0 20px;
  }
`

export const TeamStoreCreator = styled.div`
  display: flex;
`

export const StyledSpin = styled(Spin)`
  position: fixed !important;
  width: 100%;
`

export const LoadingContainer = styled.div`
  width: 100%;
  align-items: center;
  padding-top: 48px;
  justify-content: center;
  padding-bottom: 50px;
  display: flex;
  align-items: center;
`

export const ImageSkeleton = styled.div`
  width: 380px;
  min-height: 608px;
  margin-top: 24px;
  opacity: 0.6;
  margin-bottom: 18px;
  border: 1px solid ${GRAY_LIGHT};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.07);
  background: ${GRAY_SKELETON};
  &:last-child {
    margin-left: 30px;
  }
  @media (min-width: 320px) and (max-width: 748px) {
    &:last-child {
      margin-left: 0px;
      margin-top: 32px;
    }
  }
`

export const Title = styled.p`
  margin: 40px 0;
  font-weight: 600;
  font-size: 20px;
  text-transform: uppercase;
  text-align: center;

  @media (min-width: 320px) and (max-width: 748px) {
    margin: 40px 20px;
  }
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background: ${WHITE};
  width: 340px;
  margin-left: 30px;
  transition: all 0.25s;
  cursor: pointer;
  &:hover {
    box-shadow: 0 3px 11px 1px rgba(0, 0, 0, 0.15);
  }
  &:first-child {
    margin-left: 0px;
  }
  border: 1px solid ${GRAY_LIGHT};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.07);
  position: relative;
  @media (max-width: 1280px) {
    width: 268px;
  }
  @media (max-width: 768px) {
    width: auto;
    flex: 1;
  }
  @media (max-width: 698px) {
    margin-left: 0px;
    margin-top: 42px;
    &:first-child {
      margin-top: 0px;
    }
  }
`

export const CardBadge = styled.img`
  max-width: 96px;
  position: absolute;
  left: calc(50% - 48px);
  top: -20px;
  box-shadow: 0px -1px 3px -1px #a3a3a3;
  border-radius: 3px;
`

export const CardTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  text-transform: uppercase;
  color: ${BLACK};
  background: ${GRAY_LIGHTEST};
  text-align: center;
  padding: 8px;
`

export const TeamStoreCardsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 320px) and (max-width: 748px) {
    flex-flow: column;
  }
`

export const List = styled.ul`
  padding: 0;
  margin: 0 28px;
  list-style: none;
  text-align: center;
  line-height: 1.1;
  font-size: 12.5px;
  @media (max-width: 1280px) {
    font-size: 11px;
  }
  @media (max-width: 698px) {
    line-height: 1;
  }
`

export const ListNormal = styled.ul`
  padding: 0;
  margin: 0 28px;
  list-style: none;
  text-align: center;
`

export const Item = styled.li`
  margin-bottom: 10px;
`

export const PaymentIcons = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  margin: 0 30px;
  height: 40px;
  margin-bottom: 22px;
`

export const Icon = styled.img`
  width: 100%;
  max-width: 90px;
  margin-right: 16px;
`

export const SelectTeamStoreButton = styled(Button)`
  height: 40px;
  border: 2px solid ${RED};
  border-radius: 2px;
  background-color: ${WHITE};
  color: ${RED};
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;
  text-align: center;
  width: 200px;
  margin: 0 auto;
  margin-bottom: 28px;
`

export const TeamBanner = styled.img`
  max-width: 160px;
  width: 100%;
  margin-bottom: 4px;
`

export const TeamImage = styled.img`
  width: 100%;
  object-fit: cover;
  margin-bottom: 20px;
  height: 154px;
  @media (max-width: 1280px) {
    height: 114px;
  }
  @media (max-width: 698px) {
    height: 100x;
  }
`

export const TeamImageFixed = styled.img`
  width: 100%;
  object-fit: contain;
  margin-bottom: 20px;
  height: 154px;
  padding: 22px;
  background: #f1f4f5;
  @media (max-width: 1280px) {
    height: 114px;
  }
  @media (max-width: 698px) {
    height: 100px;
    padding: 12px;
  }
`

export const PaymentMethodsText = styled.div`
  text-align: center;
  margin-top: 6px;
  margin-bottom: 10px;
`

export const BottomSection = styled.div`
  flex: 1;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 12px;
  margin-bottom: 24px;
`

export const BottomImage = styled.img`
  max-width: 194px;
`

export const CardNormal = styled.div`
  display: flex;
  flex-direction: column;
  background: ${WHITE};
  min-height: 588px;
  width: 340px;
  margin-left: 30px;
  transition: all 0.25s;
  cursor: pointer;
  &:hover {
    box-shadow: 0 3px 11px 1px rgba(0, 0, 0, 0.15);
  }
  &:first-child {
    margin-left: 0px;
  }
  border: 1px solid ${GRAY_LIGHT};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.07);
  position: relative;
  @media (max-width: 1280px) {
    width: 268px;
  }
  @media (max-width: 768px) {
    width: auto;
    flex: 1;
  }
  @media (max-width: 698px) {
    margin-left: 0px;
    margin-top: 42px;
    &:first-child {
      margin-top: 0px;
    }
  }
`

export const CardTitleNormal = styled.div`
  font-weight: 600;
  font-size: 20px;
  text-transform: uppercase;
  color: ${BLACK};
  background: ${GRAY_LIGHTEST};
  text-align: center;
  padding: 10px;
`

export const TeamBannerNormal = styled.img`
  max-width: 220px;
  width: 100%;
  margin-bottom: 4px;
`

export const TeamImageNormal = styled.img`
  width: 100%;
  object-fit: cover;
  margin-bottom: 24px;
  height: 200px;
  object-position: 0 20%;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MyTeamStores/TypeSelection/styledComponents.tsx